const key = "igene-patient";

/**
 * save Patient data to local storage
 * @param {any} item  patient object
 */
const SaveData = item => {
	localStorage.setItem(key, JSON.stringify(item));
};

/**
 * Read patient data from local storage
 */
const ReadData = () => {
	const data = localStorage.getItem(key);
	if (data) return JSON.parse(data);
	return null;
};

export { SaveData, ReadData };
